<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal" @submit.prevent="subscribe">
            <h3>7-Step Course</h3>
            <div class="modal-content">
                <div class="field">
                    <label>Leave us your email address and we'll send you the course <em>ASAP</em>!</label>
                    <input type="text" v-model="email" placeholder="you@example.com">
                </div>
            </div>
            <div class="modal-actions">
                <a @click="show = false" href="javascript:;" class="cancel">Cancel</a>
                <button>
                    Learn <em>Now</em>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['app'],
    data() {
        return {
            show: false,
            email: ''
        };
    },
    methods: {
        subscribe() {
            var _ = this;

            // BOOM!
        }
    }
};
</script>
